import { render, staticRenderFns } from "./Grouping.vue?vue&type=template&id=7d36b954&scoped=true&"
import script from "./Grouping.vue?vue&type=script&lang=js&"
export * from "./Grouping.vue?vue&type=script&lang=js&"
import style0 from "./Grouping.vue?vue&type=style&index=0&id=7d36b954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d36b954",
  null
  
)

export default component.exports